"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTitleMargin = void 0;
var defaultTitleMargin = {
    margin: {
        desktop: '0 0 60px',
        tablet: '0 0 40px',
        mobile: '0 0 30px'
    }
};
exports.defaultTitleMargin = defaultTitleMargin;
//# sourceMappingURL=General.js.map